module.exports = __webpack_public_path__ + "img/timelapse-art.e62a789f.webp";